/*
 * @Author: Teemo Ding
 * @Date: 2021-06-09 13:56:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-05 15:50:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/ListPage/index.tsx
 */
import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import Warning from '@/src/components/Antd/Modal/WarningModal';
import { Modal } from 'src/components/Antd';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { dispatch } from 'src/store';
import { NULL } from 'src/tools/constant';
import { modal } from 'src/utils/Modal';
import Alias from './Alias';
import Preview from './Preview';

import {
  getContent,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getState,
  initAliasList,
  validation,
} from './slice';

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

import styles from './css.less';
// import Preview from './Preview';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  return { canViewDetails, canCreate };
};

const SalesChannelProductAlias = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;

  const history = useHistory();

  const [modalContent, setModalContent] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [noProductWarning, setNoProductWarning] = useState(false);
  const productName = useSelector(getContent('productName'));
  // const _d = useDispatch();
  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
    aliasUuid: string;
  } = useParams();
  const { saleChannelUuid } = _params;

  const [loaded] = useState(true);

  const { canViewDetails, canCreate } = permissions(saleChannelUuid);

  const child = [
    {
      body: (
        <Alias
          setShowModal={setShowModal}
          setModalContent={setModalContent}
          setModalTitle={setModalTitle}
          isOnPrimaryLanguage={isOnPrimaryLanguage}
          disabled={!canCreate}
        />
      ),
      key: 'TopConfig',
    },
  ];

  return (
    <div className={styles.container}>
      <Warning
        visible={noProductWarning}
        header={getI18n('general.hOCTitle.setupproductfirst')}
        cancelText={getI18n('salesChannelProductAlias.listPage.gotosettings')}
        afterClose={() => {
          history.push(
            `/salesChannel/products/link/${saleChannelUuid}/${NULL}`,
          );
        }}
        onCancel={() => {
          setNoProductWarning(false);
        }}>
        {getI18n('general.hOCTitle.setupproductfirst')}
      </Warning>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        headerConfig={{
          description: (canViewDetails && productName) || '',
          topTitle: salesChannelName,
          hasModified,
          submit: canCreate && submitData,
          onDiscard,
          onGoBack,
        }}
        leftChild={
          canViewDetails ? (
            <div className={styles.left}>
              <Preview />
            </div>
          ) : (
            <div className={styles.content}>
              {getI18n('general.permission.permissiondenied')}
            </div>
          )
        }
        rightChild={
          loaded && canViewDetails ? (
            <RightConfigWrapper
              title={getI18n('salesChannelProductAlias.listPage.alias')}
              subtitle={getI18n(
                'salesChannelProductAlias.listPage.filloutoriginalproduct',
              )}
              elements={child}
            />
          ) : null
        }
      />
      <Modal
        title={modalTitle}
        visible={showModal}
        width={600}
        onCancel={() => setShowModal(false)}>
        {modalContent}
      </Modal>
    </div>
  );
};
export default BasicPageHOC(SalesChannelProductAlias, {
  getState,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  queryData: (params, qParams, history) => {
    const { salesChannelProductUuid, saleChannelUuid } = params;
    if (salesChannelProductUuid === NULL) {
      modal.error({
        title: getI18nFromGeneral('general.hOCTitle.setupproductfirst'),
        content: getI18nFromGeneral('general.hOCTitle.setupproductfirst'),
        onCancel: () => {
          history.push(
            `/salesChannel/products/link/${saleChannelUuid}/${NULL}`,
          );
        },
        onCancelText: getI18nFromGeneral(
          'general.antd.Modal.ModalFooter.confirm',
        ),
      });
    } else {
      dispatch(
        initAliasList({ body: salesChannelProductUuid, params: qParams }),
      );
    }
  },
});
